import React from 'react'

import { useModalContext } from '@fourthwall/components'

import { useDashboardFeatureFlags } from '../../../../../../components/utils/DashboardFeatureFlags'
import { usePageLayoutContext } from '../../../../providers/PageLayoutProvider'
import { AddSectionModalContainer } from '../../../PageCustom/modules/LayoutBlocks/modules/AddSectionModal'
import { AddSectionModalContainer as AddSectionModalContainerV2 } from '../../../PageCustom/modules/LayoutBlocks/modules/AddSectionModalV2'
import { useThemeLivePreviewContext } from '../../providers/ThemeLivePreviewProvider'
import * as S from './styled'

type Props = {
  position: 'top' | 'bottom'
}

export const AddSectionToolbar = ({ position }: Props) => {
  const { rect, activeSectionName, activeSectionKey } = useThemeLivePreviewContext()
  const { pageLayoutQuery } = usePageLayoutContext()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  const { open } = useModalContext()
  const borderWidth = 2

  const block = pageLayoutQuery.data?.sectionsGroups.find((block) =>
    block.sections.some((section) => section.sectionKey === activeSectionKey),
  )

  const sectionIndex = pageLayoutQuery.data?.sectionsGroups.reduce((acc, block) => {
    const index = block.sections.findIndex((section) => section.sectionKey === activeSectionKey)
    if (index !== -1) {
      acc = index
    }

    return acc
  }, -1)

  const handleModalOpen = () => {
    if (!block || sectionIndex === undefined) return

    if (dashboardFeatureFlags.themeEditorSectionStyles.enabled) {
      open(AddSectionModalContainerV2, {
        blockId: block.id,
        type: block?.type || '',
        position: position === 'top' ? sectionIndex + 1 : sectionIndex + 2,
      })
    } else {
      open(AddSectionModalContainer, {
        blockId: block.id,
        type: block?.type || '',
        position: position === 'top' ? sectionIndex + 1 : sectionIndex + 2,
      })
    }
  }

  if (!activeSectionName || !block?.modifiable || rect.top + rect.height < 60) return null

  return (
    <S.Layout
      style={{
        top: position === 'top' ? (rect.top > 0 ? 0 : Math.abs(rect.top)) - borderWidth : undefined,
        bottom:
          position === 'bottom'
            ? (rect.bottom > 0 ? 0 : Math.abs(rect.bottom)) - borderWidth
            : undefined,
        left: '50%',
        transform: 'translateX(-50%)',
      }}
    >
      <S.Button
        onClick={() => {
          handleModalOpen()
        }}
      >
        Add section
      </S.Button>
    </S.Layout>
  )
}
